import React, { useState } from "react";
import { Button } from "react-bootstrap";
import "./Common_Call_Button.css";
import Send_Button_Modal from "../../common-modals/send-btn-modal/Send_Button_Modal";
import Call_Now_Modal from "../../common-modals/call-now-modal/Call_Now_Modal";

function Common_Call_Button({
  vendor,
  onClick,
  onClick2,
  onClick3,
  onClick4,
  onClick5,
}) {
  const [showInquiry, setShowInquiry] = useState(false);
  const [showCall, setShowCall] = useState(false);
  return (
    <div className="vendor-buttons">
      <Button className="call-btn" onClick={onClick2 || onClick4 || onClick5}>
        Call Now
      </Button>
    </div>
  );
}

export default Common_Call_Button;
